import { useSearchParams } from 'react-router-dom'
import { capitalize, startCase } from 'lodash'
import React from 'react'
import { observer } from 'mobx-react-lite'
import { usePipelinesPage } from 'app/components/pipelines-page/usePipelinesPage'
import { PipelinesComponent } from 'app/components/pipelines-page/PipelinesComponent'

export const handle = {
  title: `Pipelines`,
  breadcrumb: (matches: any[]) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let [searchParams] = useSearchParams()
    let name = matches[0].data.subpages.find((subpage) => subpage.id === searchParams.get(`tab`))?.name
    return [
      <span key="pipelines" className="last:text-body-sm hover:text-subtle">
        Pipelines
      </span>,
      <span key={searchParams.get(`tab`)}>{capitalize(name) || startCase(searchParams.get(`tab`) ?? ``)}</span>,
    ]
  },
  pathname: () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let [searchParams] = useSearchParams()
    return [`/pipelines`, `/pipelines?tab=${searchParams.get(`tab`)}`]
  },
}

export default observer(function Pipelines(): React.ReactElement {
  const props = usePipelinesPage()
  return <PipelinesComponent {...props} />
})
